import React from "react";
import styled from "../style.module.css";

const PERIODS = [
  { label: "3M", value: 3 },
  { label: "6M", value: 6 },
  { label: "12M", value: 12 },
  { label: "All", value: "all" },
];

const TopBar = ({ period, onPeriodChange }) => (
  <div className={styled.topBar}>
    <div>
      <h1 className={styled.brandTitle}>Executive Overview</h1>
      <p className={styled.topBarCaption}>
        Trends reflect the selected range · Totals &amp; revenue are as of today
      </p>
    </div>
    <div className={styled.periodSelectorWrap}>
      <span className={styled.periodScopeNote}>Applies to trend charts only</span>
      <div className={styled.periodSelector} role="group" aria-label="Time range">
        {PERIODS.map((p) => (
          <button
            key={p.label}
            type="button"
            className={`${styled.periodBtn} ${period === p.value ? styled.periodBtnActive : ""}`}
            onClick={() => onPeriodChange(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default TopBar;
